<div class="banner" [ngClass]="position">TEST</div>
